import { memo } from 'react';
import { Avatar } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

const toInitials = (name = '') =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join('');

/**
 * Overlapping avatars of a group's first members plus the member count ("No members yet" when empty).
 *
 * @param {object} props
 * @param {Array<{ id: string, name: string }>} props.members Preview of the first members.
 * @param {number} props.count Total members of the group.
 */
function GroupMembersPreview({ members = [], count }) {
  const { t } = useTranslation('people-access');

  if (count === 0) {
    return <span className="text-xs text-content-muted">{t('invite.groups.noMembers')}</span>;
  }

  return (
    <div className="flex items-center gap-2">
      <div className="flex -space-x-1.5">
        {members.map((member) => (
          <Avatar
            key={member.id}
            size="md"
            alt={member.name}
            initials={toInitials(member.name)}
            className="border border-surface bg-accent/20 text-[10px] text-content"
          />
        ))}
      </div>
      <span className="text-xs text-content-muted">{t('invite.groups.members', { count })}</span>
    </div>
  );
}

export default memo(GroupMembersPreview);
